/**
 * Vlastný text (HTML z BO Froala) je vyplnený, ak po odstránení tagov obsahuje
 * niečo iné než whitespace. Prázdny Froala editor vracia napr. `<p><br></p>` —
 * to sa považuje za nevyplnené (BO ukladá null, toto je poistka pre staré dáta).
 */
export function hasCustomText(
  value: string | null | undefined
): value is string {
  if (typeof value !== 'string') return false
  const textContent = value
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/g, ' ')
    .trim()
  return textContent.length > 0
}
